<script lang="ts" setup>
import { ref, computed, onMounted, onUnmounted } from "vue"

const props = withDefaults(
  defineProps<{
    stroke?: string
    strokeWidth?: number
  }>(),
  { stroke: "currentColor", strokeWidth: 1 },
)

const wrapper = ref<HTMLElement | null>(null)
const width = ref(0)
const height = ref(0)

let ro: ResizeObserver | null = null

onMounted(() => {
  if (!wrapper.value) return
  ro = new ResizeObserver(entries => {
    const { width: w, height: h } = entries[0].contentRect
    width.value = w
    height.value = h
  })
  ro.observe(wrapper.value)
})

onUnmounted(() => {
  ro?.disconnect()
})

const d = computed(() => {
  const w = width.value
  const h = height.value
  if (w === 0 || h === 0) return ""
  const tip = props.strokeWidth / 2
  return `M${tip} ${tip} L${w - tip} ${h - tip} M${w - tip} ${tip} L${tip} ${h - tip}`
})
</script>

<template>
  <div ref="wrapper" class="w-full h-full overflow-visible">
    <svg
      :viewBox="`0 0 ${width} ${height}`"
      preserveAspectRatio="none"
      class="overflow-visible"
      style="width: 100%; height: 100%; display: block"
    >
      <path
        :d="d"
        fill="none"
        :stroke="stroke"
        :stroke-width="strokeWidth"
        stroke-linecap="butt"
        stroke-linejoin="miter"
      />
    </svg>
  </div>
</template>
